import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from 'lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground',
        secondary: 'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive: 'border-[#f3dde4] bg-[#fff0f2] text-[#a74b54] hover:bg-[#fff0f2]',
        outline: 'text-foreground',
        hajj: 'border-transparent bg-hajj-primary text-white hover:hajj-secondary',
        success: 'border-[#d4eae2] bg-[#eff9f5] text-[#247e6e] hover:bg-[#eff9f5]',
        pending: 'border-[#e1e7e3] bg-[#fafcfb] text-[#586b60]',
        info: 'border-[#e3ebf6] bg-[#f0f5fc] text-[#48688a]',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

const Badge = ({ className, variant, ...props }) => {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
};

export { Badge, badgeVariants };
